module.exports = __webpack_public_path__ + "assets/zjmp_icon3.d86139ab.svg";